import { MdAddBox } from "react-icons/md";
import { RiDashboardFill } from "react-icons/ri";
import { FaBoxes, FaCalculator, FaReceipt } from "react-icons/fa";
import { LuPackageSearch } from "react-icons/lu";
import { SiNdr } from "react-icons/si";
import { IoNotifications, IoSettingsSharp, IoWallet } from "react-icons/io5";
import { BiSolidReceipt } from "react-icons/bi";
import { TbHelpSquareRoundedFilled, TbUserScan } from "react-icons/tb";
import { AiOutlineNodeIndex } from "react-icons/ai";
import { TfiBlackboard, TfiStatsUp } from "react-icons/tfi";
import { FaBox } from "react-icons/fa";
import { faker } from "@faker-js/faker"
import { BsPersonBoundingBox } from "react-icons/bs";
import { HiMiniUserGroup } from "react-icons/hi2";
import { LiaBlogSolid } from "react-icons/lia";
import { TbLogs } from "react-icons/tb";
import { PiPresentationFill } from "react-icons/pi";

export const SidebarMenu = {
    primary: [{
        title: "Dashboard",
        path: "/",
        icon: RiDashboardFill,
    },
    {
        title: "Booked Orders",
        path: "bookedOrders",
        icon: FaBoxes,
    },
    ],
    secondary: [{
        title: "Tracking",
        path: "tracking",
        icon: LuPackageSearch,
    },
    {
        title: "NDR",
        path: "ndr",
        icon: SiNdr,
    },
    {
        title: "Billing",
        path: "billing",
        icon: FaReceipt,
    },
    {
        title: "Reports",
        path: "reports",
        icon: BiSolidReceipt,
    },
    {
        title: "KYC Requests",
        path: "kycRequests",
        icon: TbUserScan,
    },
    {
        title: "Customers",
        path: "customer",
        icon: HiMiniUserGroup
    },
    {
        title: "Blogs",
        path: "blogs",
        icon: LiaBlogSolid,
    },

    {
        title: "Settings",
        path: "settings",
        icon: IoSettingsSharp,
    },
    {
        title: "Support",
        path: "support",
        icon: TbHelpSquareRoundedFilled,
    }
    ],
    ternary: [{
        title: "Logs",
        path: "logs",
        icon: TbLogs,
    },
    {
        title: "Banner",
        path: "banners",
        icon: PiPresentationFill,
    },
    {
        title: "Notifications",
        path: "notifications",
        icon: IoNotifications,
    },
    ],
};
export const StatsShipment = [
    { statusName: 'Total Shipments', statusNumber: 1672 },
    { statusName: 'Booked', statusNumber: 1672 },
    { statusName: 'Pending Booking', statusNumber: 1672 },
    { statusName: 'In-Transit', statusNumber: 1672 },
    { statusName: 'Delivered', statusNumber: 1672 },
];
export const StatsNdr = [
    { statusName: 'Total NDR', statusNumber: 1672 },
    { statusName: 'Action Requires', statusNumber: 1672 },
    { statusName: 'Action Requested', statusNumber: 1672 },
    { statusName: 'Delivered', statusNumber: 1672 },
    { statusName: 'RTO', statusNumber: 1672 },
];
export const StatsCod = [
    { statusName: 'Total Remitted', statusNumber: 1672 },
    { statusName: 'Last Remittance', statusNumber: 1672 },
    { statusName: 'Next Remittance', statusNumber: 1672 },
    { statusName: 'Total Remitted Due', statusNumber: 1672 },
];
export const StatsCodDue = [
    { statusName: 'Received from Courier Partner ', statusNumber: 1672 },
    { statusName: 'Remittance given to Customer  ', statusNumber: 1672 },
    { statusName: 'Remittance Due to Customer  ', statusNumber: 1672 },
    { statusName: 'Total Remittance Due From Courier Partner  ', statusNumber: 1672 },
];
export const StatsCodCustomerDue = [
    { statusName: 'Total Remittance Due to Customer  ', statusNumber: 1672 },
    { statusName: 'Total Remittance given to Customer  ', statusNumber: 1672 },
    { statusName: ' Remittance Received from Courier Partner  ', statusNumber: 1672 },
    { statusName: 'Remittance Due from Courier Partner  ', statusNumber: 1672 },
    { statusName: 'Last Remittance (20-01-25)  ', statusNumber: 1672 },
    { statusName: 'Next  Remittance   ', statusNumber: 1672 },
    { statusName: 'Weight Dispute  ', statusNumber: 1672 },
    { statusName: 'Wallet Balance  ', statusNumber: 1672 },
];
export const DeliveryInfoData = [{
    title: "Total Revenue",
    subtitle: "Total value of delivered orders (in Rs.)",
    type: "icon",
    icon: TfiStatsUp,
    value: "46,36,266.90",
},
{
    title: "Avg. Order Cost ",
    subtitle: "Your average shipping cost of all orders",
    type: "icon",
    icon: FaBox,
    value: "46.50",
},
{
    type: "progress",
    title: "Delivered Percentage ",
    subtitle: "Total orders delivered (in percentage)",
    current: 151,
    total: 170,
    label: "orders delivered",
},
];
export const getCourierPerformanceData = (count = 100) => {
    return Array.from({ length: count }, (_, index) => {
        return {
            sNo: index + 1,
            courier: faker.helpers.arrayElement([
                "Delhivery", "XpressBees", "Blue Dart", "Ecom Express",
            ]),
            totalShipment: faker.number.int({ min: 1, max: 1000 }),
            booked: faker.number.int({ min: 1, max: 1000 }),
            pending: faker.number.int({ min: 1, max: 1000 }),
            inTransit: faker.number.int({ min: 1, max: 1000 }),
            delivered: faker.number.int({ min: 1, max: 1000 }),
            rto: faker.number.int({ min: 1, max: 1000 }),
            lostDamage: faker.number.int({ min: 1, max: 1000 }),
        };
    });
};
export const getBookedOrderData = (count = 100) => {
    return Array.from({ length: count }, (_, index) => {
        return {
            id: index + 1, // Unique ID for DataTable
            channel: faker.helpers.arrayElement([
                "Shopify",
                "WooCommerce",
                "Amazon",
                "Custom",
            ]),
            orderId: faker.string.numeric(12), // Generates a 12-digit numeric Order ID
            orderDate: faker.date.past().toISOString().split("T")[0], // Formats date as YYYY-MM-DD
            productName: faker.commerce.productName(),
            payment: faker.finance.amount(),
            collectableAmount: faker.number.int({ min: 100, max: 5000 }), // Generates a whole number
            paymentMode: faker.helpers.arrayElement(["COD", "Prepaid"]),
            customer: faker.person.fullName(),
            zipCode: faker.string.numeric(6), // Ensures exactly 6 digits for Zip Code
            weight: faker.finance.amount({ min: 0.5, max: 50, dec: 2 }), // Generates weight with 2 decimal places
            status: faker.helpers.arrayElement(["Booked", "NotBooked"]),
        };
    });
};
export const getTrackingOrderData = (count = 100) => {
    return Array.from({ length: count }, (_, index) => {
        return {
            id: index + 1,
            channel: faker.helpers.arrayElement([
                "Shopify",
                "WooCommerce",
                "Amazon",
                "Custom",
            ]),
            orderId: faker.string.numeric({
                length: faker.number.int({ min: 12, max: 12 }),
            }),
            bookingDate: faker.date.past().toISOString().split("T")[0],
            shippingId: faker.string.numeric({
                length: faker.number.int({ min: 12, max: 12 }),
            }),
            product: faker.commerce.product(),
            payment: faker.finance.amount(),
            paymentMode: faker.helpers.arrayElement(["COD", "Prepaid"]),
            customer: faker.person.fullName(),
            status: faker.helpers.arrayElement([
                "Booked",
                "Pending Pickup",
                "In-Transit",
                "Out for Delivery",
                "Delivered",
                "Cancelled",
                "Lost",
                "Damaged",
                "RTO All",
                "RTO In-Transit",
                "RTO Delivered",
                "RTO Lost"
            ]),
            carrier: faker.helpers.arrayElement([
                "Delhivery",
                "XpressBees",
                "Blue Dart",
                "Ecom Express",
            ]),
            weight: faker.number.float({ min: 0.5, max: 10, precision: 0.01 }).toFixed(2) +
                " kg", // weight in kg


        };
    });
};
export const getNdrOrderData = (count = 100) => {
    return Array.from({ length: count }, (_, index) => {
        return {
            id: index + 1,
            channel: faker.helpers.arrayElement([
                "Shopify",
                "WooCommerce",
                "Amazon",
                "Custom",
            ]),
            orderId: 1000000000 + index, // Generates a 12-digit numeric Order ID
            bookingDate: faker.date.past().toISOString().split("T")[0],
            shippingId: faker.string.numeric({
                length: faker.number.int({ min: 12, max: 12 }),
            }),
            awbId: faker.string.numeric({
                length: faker.number.int({ min: 12, max: 12 }),
            }),
            payment: faker.finance.amount(),
            paymentMode: faker.helpers.arrayElement(["COD", "Prepaid"]),
            customer: faker.person.fullName(),
            ndrStatus: faker.helpers.arrayElement([
                "Action Required",
                "Action Requested",
                "Delivered",
                "RTO",
            ]),
            status: faker.helpers.arrayElement([
                "Booked",
                "Pending Pickup",
                "In-Transit",
                "Out for Delivery",
                "Delivered",
                "Cancelled",
                "Lost",
                "Damaged",
                "RTO ALL",
                "RTO In-Transit",
                "RTO Delivered",
                "RTO Lost"
            ]),
            carrier: faker.helpers.arrayElement([
                "Delhivery",
                "XpressBees",
                "Blue Dart",
                "Ecom Express",
            ]),
            exceptionInfo: faker.helpers.arrayElement([
                "Invalid Address",
                "Incomplete Address",
                "Pincode Mismatch",
                "Remote Area - Delivery Not Available",
                "Customer Not Available",
                "Security Restriction",
                "Package Refused by Customer",
                "Payment Declined",
                "COD Not Available",
                "Damaged Item",
                "Wrong Item Received",
                "Missing Items in Order",
                "Invalid Phone Number",
                "Customer Not Responding",
                "Delivery Rescheduled by Customer",
                "Shipment Lost in Transit",
                "Held at Customs",
                "Return to Origin Initiated",
                "Delivery Delayed due to Weather"
            ]),

        };
    });
};
export const getCreditNoteData = (count = 100) => {
    return Array.from({ length: count }, (_, index) => {
        return {
            customerName: faker.person.fullName(),
            customerId: faker.string.numeric({
                length: faker.number.int({ min: 12, max: 12 }),
            }),
            creditNo: `${faker.string.alpha({ length: 2 }).toUpperCase()}${String(index + 1).padStart(6, '0')}`,
            creditDate: faker.date.past().toISOString().split("T")[0], // Formats date as YYYY-MM-DD
            creditPeriod: `${faker.date.past().toLocaleString('default', { month: 'long' })} ${faker.date.past().getFullYear()}`,
            creditAmount: faker.finance.amount(),
        };
    });
}
export const getKycRequests = (count = 100) => {
    return Array.from({ length: count }, (_, index) => {
        return {
            id: index + 1,
            customerName: faker.person.fullName(),
            customerId: faker.string.numeric({
                length: faker.number.int({ min: 12, max: 12 }),
            }),
            mobile: faker.phone.number('###-###-####'),
            mail: faker.internet.email(),
            firmName: faker.company.name(),
            gstNumber: faker.string.hexadecimal({ length: 15 }), // 15-digit GST number
        };
    });
}
export const getCodRemittanceData = (count = 100) => {
    return Array.from({ length: count }, (_, index) => {
        return {
            id: index + 1,
            customerName: faker.person.fullName(),
            customerId: faker.string.numeric({
                length: faker.number.int({ min: 12, max: 12 }),
            }),
            remittanceId: faker.string.numeric({
                length: faker.number.int({ min: 12, max: 12 }),
            }),
            codAmount: faker.finance.amount({
                min: 10,
                max: 1000
            }),
            paymentDate: faker.date.past().toISOString().split("T")[0],
            walletPayment: faker.finance.amount({
                min: 10,
                max: 1000
            }),
            accountPayment: faker.finance.amount({
                min: 10,
                max: 1000
            }),
            utrReference: faker.finance.routingNumber(),
        };
    });
};
export const getCustomerCodRemittanceData = (count = 100) => {
    return Array.from({ length: count }, (_, index) => {
        return {
            id: index + 1,
            awb: faker.string.numeric({
                length: faker.number.int({ min: 12, max: 12 }),
            }),
            shippingId: faker.string.numeric({
                length: faker.number.int({ min: 12, max: 12 }),
            }),
            bookingDate: faker.date.past().toISOString().split("T")[0],
            codAmountDue: faker.finance.amount({
                min: 10,
                max: 1000
            }),
            Courier: faker.helpers.arrayElement([
                "Delhivery",
                "XpressBees",
                "Blue Dart",
                "Ecom Express",
            ]),
            channel: faker.helpers.arrayElement([
                "Shopify",
                "WooCommerce",
                "Amazon",
                "Custom",
            ]),
        };
    });
};
export const getCustomerInfo = (count = 100) => {

    return Array.from({ length: count }, (_, index) => {
        // Determine if this entry will have credit or debit


        return {
            id: index + 1, // Unique ID for DataTable
            // Generates a 12 to 15 digit number
            customerId: faker.string.numeric({
                length: faker.number.int({ min: 12, max: 12 }),
            }),
            firmName: faker.company.name(),
            customerName: faker.person.fullName(),
            mobile: faker.phone.number('###-###-####'),
            city: faker.location.city(),
            // Formats date as YYYY-MM-DD
            state: faker.helpers.arrayElement([
                "Andhra Pradesh",
                "Arunachal Pradesh",
                "Assam",
                "Bihar",
                "Chhattisgarh",
                "Goa",
                "Gujarat",
                "Haryana",
                "Himachal Pradesh",
                "Jharkhand",
                "Karnataka",
                "Kerala",
                "Madhya Pradesh",
                "Maharashtra",
                "Manipur",
                "Meghalaya",
                "Mizoram",
                "Nagaland",
                "Odisha",
                "Punjab",
                "Rajasthan",
                "Sikkim",
                "Tamil Nadu",
                "Telangana",
                "Tripura",
                "Uttar Pradesh",
                "Uttarakhand",
                "West Bengal",
            ]),

        };
    });
};
export const getblogData = (count = 100) => {
    return Array.from({ length: count }, (_, index) => {
        return {
            id: index + 1,
            title: faker.lorem.sentence(),
            contactImage: faker.image.urlLoremFlickr({ category: 'courier' }),
            blogID: faker.string.numeric({
                length: faker.number.int({ min: 6, max: 6 }),
            }),
            createdDate: faker.date.past().toISOString().split("T")[0],
        };
    });
};
export const getBannerData = (count = 100) => {
    return Array.from({ length: count }, (_, index) => {
        return {
            id: index + 1,
            sNo: index + 1,
            title: faker.lorem.sentence(),
            contactImage: faker.image.urlLoremFlickr({ category: 'courier' }),
            bannerId: faker.string.numeric({
                length: faker.number.int({ min: 6, max: 6 }),
            }),
            descreption: faker.lorem.sentence(),
        };
    });
};
export const getEscalationData = (count = 100) => {
    return Array.from({ length: count }, () => {
        return {
            customerName: faker.person.fullName(),
            customerId: faker.string.numeric({
                length: faker.number.int({ min: 12, max: 12 }),
            }),
            Courier: faker.helpers.arrayElement([
                "Delhivery",
                "XpressBees",
                "Blue Dart",
                "Ecom Express",
            ]),
            awbId: faker.string.numeric({
                length: faker.number.int({ min: 12, max: 12 }),
            }),
            escalationId: faker.string.numeric(12),
            Date: faker.date.past().toISOString().split("T")[0], // Formats date as YYYY-MM-DD
            status: faker.helpers.arrayElement(["All", "New", "In Progress", "Resolved"]),
            shippingId: faker.string.numeric(12),
            shipmentStatus: faker.helpers.arrayElement([
                "Booked",
                "Pending Pickup",
                "In-Transit",
                "Out for Delivery",
                "Delivered",
                "Cancelled",
                "Lost",
                "Damaged",
                "RTO ALL",
                "RTO In-Transit",
                "RTO Delivered",
                "RTO Lost"
            ]),
            escalationtype: faker.helpers.arrayElement([
                "pickupDelivery",
                "shipmentNdrRto",
                "shipmentDispute",
                "finance",
                "kycBankVerification",
                "technicalSupport",
                "billingTaxation",
                "claims",
                "other"
            ]),
            escalationStatus: faker.helpers.arrayElement([
                'Pending',
                "In Progress",
                "Resolved",
                "Closed",
                ,
            ])

        };
    });
};
export const getCallBackData = (count = 100) => {
    return Array.from({ length: count }, () => {
        return {
            customerName: faker.person.fullName(),
            customerId: faker.string.numeric({
                length: faker.number.int({ min: 12, max: 12 }),
            }),
            mobile: faker.phone.number('###-###-####'),
            category: faker.helpers.arrayElement([
                "Query",
                "Complaint",
                "Feedback",
                "Information",
                "Technical Issue",
                "Other",
            ]),
            message: faker.lorem.sentence(),

        };
    });
};
export const getLogsData = (count = 100) => {
    return Array.from({ length: count }, () => {
        return {
            customerName: faker.person.fullName(),
            customerId: faker.string.numeric({
                length: faker.number.int({ min: 12, max: 12 }),
            }),
            dateTime: faker.date.recent().toLocaleString(),
        };
    });
};
export const StatesOptions = {
    AN: "Andaman and Nicobar Islands",
    AP: "Andhra Pradesh",
    AR: "Arunachal Pradesh",
    AS: "Assam",
    BR: "Bihar",
    CH: "Chandigarh",
    CT: "Chhattisgarh",
    DN: "Dadra and Nagar Haveli",
    DD: "Daman and Diu",
    DL: "Delhi",
    GA: "Goa",
    GJ: "Gujarat",
    HR: "Haryana",
    HP: "Himachal Pradesh",
    JK: "Jammu and Kashmir",
    JH: "Jharkhand",
    KA: "Karnataka",
    KL: "Kerala",
    LA: "Ladakh",
    LD: "Lakshadweep",
    MP: "Madhya Pradesh",
    MH: "Maharashtra",
    MN: "Manipur",
    ML: "Meghalaya",
    MZ: "Mizoram",
    NL: "Nagaland",
    OR: "Odisha",
    PY: "Puducherry",
    PB: "Punjab",
    RJ: "Rajasthan",
    SK: "Sikkim",
    TN: "Tamil Nadu",
    TG: "Telangana",
    TR: "Tripura",
    UP: "Uttar Pradesh",
    UT: "Uttarakhand",
    WB: "West Bengal"
};
export const statesOptionsArray = Object.keys(StatesOptions).map((key) => ({
    label: StatesOptions[key],
    value: key,
}));
export const getStateLabel = (value) => {
    return StatesOptions[value] || value;
};
export const escalationTypes = [
    { label: "Pickup & Delivery", value: "pickupDelivery" },
    { label: "Shipment NDR & RTO", value: "shipmentNdrRto" },
    { label: "Weight Dispute", value: "weightDispute" },
    { label: "Finance", value: "finance" },
    { label: "KYC & Bank Verification", value: "kycBankVerification" },
    { label: "Technical Support", value: "technicalSupport" },
    { label: "Billing & Taxation", value: "billingTaxation" },
    { label: "Claims", value: "claims" },
    { label: "Other", value: "other" },
];

export const getEscalationTypeLabel = (value) => {
    const escalationType = escalationTypes.find(
        (type) => type.value === value
    );
    return escalationType?.label || value;
};
export const subcategoryOptions = [
    // pickupDelivery related
    {
        label: "Delay in Forward Delivery",
        value: "delayForwardDelivery",
        category: "pickupDelivery",
    },
    {
        label: "Delay in RTO Delivery",
        value: "delayRtoDelivery",
        category: "pickupDelivery",
    },
    {
        label: "Delay in Pickup",
        value: "delayPickup",
        category: "pickupDelivery",
    },
    {
        label: "Shipment Showing as Lost/Damaged in Tracking",
        value: "shipmentLostDamaged",
        category: "pickupDelivery",
    },

    // shipmentNdrRto
    {
        label: "Issue Over Undelivered Shipment",
        value: "undeliveredShipment",
        category: "shipmentNdrRto",
    },
    {
        label: "Request to Mark Shipment as RTO",
        value: "markShipmentRto",
        category: "shipmentNdrRto",
    },

    // shipmentDispute
    {
        label: "Issues with Delivered Shipment",
        value: "deliveredShipment",
        category: "weightDispute",
    },
    {
        label: "Issue Over Weight Discrepancy",
        value: "weightDiscrepancy",
        category: "weightDispute",
    },

    // finance
    {
        label: "Delay in COD Remittance",
        value: "delayCodRemittance",
        category: "finance",
    },
    {
        label: "Request to Hold COD Remittance",
        value: "holdCodRemittance",
        category: "finance",
    },
    {
        label: "Transfer Wallet Amount into My Bank Account",
        value: "walletToBank",
        category: "finance",
    },
    {
        label: "Issue in Recharging Wallet",
        value: "walletRechargeIssue",
        category: "finance",
    },
    {
        label: "Upgrade/Downgrade ICC Plan",
        value: "iccPlanChange",
        category: "finance",
    },
    {
        label: "Wallet Showing Negative Balance",
        value: "walletNegativeBalance",
        category: "finance",
    },

    // billingTaxation
    {
        label: "Issues with KYC Verification",
        value: "kycVerificationIssues",
        category: "kycBankVerification",
    },
    {
        label: "Facing Issues in Verifying Bank Account Details",
        value: "bankVerificationIssue",
        category: "kycBankVerification",
    },

    // technicalSupport
    {
        label: "Issues With Channel & API Integration",
        value: "channelApiIssues",
        category: "technicalSupport",
    },
    {
        label: "Issue In Managing Orders",
        value: "orderManagementIssue",
        category: "technicalSupport",
    },
    {
        label: "Order/Shipment Cancellation",
        value: "orderCancellation",
        category: "technicalSupport",
    },

    // billingTaxation
    {
        label: "Account Ledger Statement Needed",
        value: "accountLedgerNeeded",
        category: "billingTaxation",
    },
    {
        label: "TDS Form Required for Tax Return",
        value: "tdsFormNeeded",
        category: "billingTaxation",
    },
    {
        label: "Issue with Invoice",
        value: "invoiceIssue",
        category: "billingTaxation",
    },
    {
        label: "Need Help with GST",
        value: "gstHelp",
        category: "billingTaxation",
    },

    // claims
    {
        label: "Transfer Lost Shipment Refund to My Bank Account",
        value: "lostShipmentRefund",
        category: "claims",
    },
    {
        label: "Amount Not Received for Lost Shipment",
        value: "lostShipmentAmount",
        category: "claims",
    },
    {
        label: "Credit Note Details Required",
        value: "creditNoteDetails",
        category: "claims",
    },
    {
        label: "Request Claim for Secure Shipment",
        value: "secureShipmentClaim",
        category: "claims",
    },

    // other
    {
        label: "Issue with Engage Services",
        value: "engageServicesIssue",
        category: "other",
    },
    {
        label: "Issue with SRF services",
        value: "srfServicesIssue",
        category: "other",
    },
    {
        label: "Issue with Direct orders",
        value: "directOrdersIssue",
        category: "other",
    },
    {
        label: "My issue is not Listed here",
        value: "otherIssue",
        category: "other",
    },
];

export const getSubcategoryLabel = (value) => {
    const subcategory = subcategoryOptions.find(
        (option) => option.value === value
    );
    return subcategory?.label || value;
};